import React, { useEffect, useRef, useState } from 'react'
import { ImageUrl } from '../../../utils/constants'
import { CustomDropdownMenuItem, CustomDropdownMenue } from '../../AdminTeamCreation/styles';
import { PropTypes } from 'prop-types';
import { toast } from 'react-toastify';
import {  GetCompanyRewardsDocuments, GetHealthDocuments, UpdateHealthDocuments } from '../../../redux/constants/apiConstants';
import { checkImageLoaded, fetchApi } from '../../../utils/methods';
import { connect } from 'react-redux';
import {  DownloadReportIcon, RecognitionEyeIcon, VerticalDotsIcon } from '../../../utils/icons';
import PdfPreview from '../../common/CommonPdfPreview/PdfPreview';
import { FileDocumentThumbnail, DocumentDetails,DocumentImage, UploadDiv } from '../../RewardsManagement/styles';
// import DeletePopupModal from '../../RewardsManagement/components/DocumentComponents/DeletePopupModal';
import PreviewImageModal from './PreviewImageModal';
import dayjs from 'dayjs';
import SkeletonLoder from '../../common/skeletonLoder';
import { NoData } from '../../SocialFeedsV2/styles';
import LazyImage from '../../common/LazyImage/LazyImage';

function ReportsDashboard({ user}) {
//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [extensionOfFile, setExtensionOfFile] = useState('');
  const [fileNameForRename, setFileNameForRename] = useState('');
  const [activeDocumentIndex, setActiveDocumentIndex] = useState(null);
  const [activeRename, setActiveRename] = useState(false);
  //   const [activeDeleteModal, setActiveDeleteModal] = useState(null);
  const fileNameRef = useRef(null);
  const [detailPopup, showDetailPopup] = useState(false);
  const [previewPopup, showPreviewPopup] = useState(false);
  const [documentData, setDocumentData] = useState(null);
  const [pdfFile, setPdfFile] = useState(null);
  const[documentsData, setdocumentsData] = useState([]);
  const[loading, setLoading]= useState(false)



  const closeModal = () => {
    showPreviewPopup(false); 
  };



  const renameDocument = async (doc_id) => {
    await fetchApi(`${UpdateHealthDocuments}`, "PUT", {id: doc_id, document_name: fileNameForRename}).then((response) => {toast.success(response.data[0]); fetchDocuments();}).catch( (error) => {toast.error(error)} );

  }

  //   const deleteRewardsDocument = async (doc_id) => {
  //     await fetchApi(`${DeleteRewardsDocumentForCompany}/${doc_id}`, "DELETE").then((response) => {toast.success(response.data[0]); setShowDeleteModal(false); refreshDocumentDashboard(companyInfo.id)}).catch( (error) => {toast.error(error)} );
  //   }


  useEffect( () => {
    fetchDocuments();
    const handleScroll = () => {
      setActiveDocumentIndex(null);
    }
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  //   const downloadFile = (ImageBase64, document_title) => {
  //     // window.console.log("this is the iamgebase",ImageBase64)
  //     const downloadLink = document.createElement("a");
  //     downloadLink.download = document_title;
  //     downloadLink.target = '_blank';
  //     downloadLink.href = ImageBase64;
  //     downloadLink.click();
  //   }

  const downloadFile = async (cloudfrontUrl, documentTitle) => {
    try {
      const response = await fetch(ImageUrl + "/" + cloudfrontUrl, { mode: "cors"});
  
      if (!response.ok) {
        throw new Error(`Failed to download file: ${response.statusText}`);
      }
  
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
  
      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = documentTitle || "download"; // Fallback filename
      document.body.appendChild(downloadLink);
      downloadLink.click();
  
      // Cleanup
      window.URL.revokeObjectURL(url);
      document.body.removeChild(downloadLink);
    } catch (error) {
      window.console.error("Error downloading file:", error);
    }
  };



  // To Fetch All Rewards Documents for a selected company
  const fetchDocuments = async () => {
    setLoading(true);
    try{
      const res = await fetchApi(`${GetHealthDocuments}/${user.uid}`, "GET");
      if(res?.data?.message){
        toast.error(res?.data?.message);
      }else{
        setdocumentsData(res.data);
        setLoading(false);
      }

    }catch(err){
      toast.error(err);
    }
    
  }
  const downloadRewardsDocument = async (document) => {

    checkImageLoaded(ImageUrl+"/"+document.document)
      .then(() => downloadFile(document.document, document.document_name))
      .catch(() => downloadFile("health-data/health-doc-fallback.png", document.document_name));

  }

  const setFileName = (docTitle) => {
    // window.console.log("extensionOfFile",extensionOfFile)
    // Find the last occurrence of a dot
    let lastDotIndex = docTitle.lastIndexOf(".");
  
    // If there's no dot OR the dot is at the beginning (hidden file case), treat it as no extension
    if (lastDotIndex === -1 || lastDotIndex === 0) {
      setFileNameForRename(docTitle);
      //   setExtensionOfFile(""); 
      return;
    }
  
    // Extract file name without extension
    let fileName = docTitle.substring(0, lastDotIndex);
    // Extract extension
    let extension = docTitle.substring(lastDotIndex + 1);
  
    // If there's a space in the extension, it's likely not an actual extension
    if (extension.includes(" ")) {
      setFileNameForRename(docTitle);
    //   setExtensionOfFile("");
    } else {
      setFileNameForRename(fileName);
    //   setExtensionOfFile(extension);
    }
  };

  const closeDetailPopup=()=>{
    showDetailPopup(false)
    
  }
  
  
  const DetailsHandle=(document)=>{
    showDetailPopup(true)
    setDocumentData(document)
  }


  // const PDFDetailsHandle=(document)=>{
  //   showPreviewPopup(true)
  //   setDocumentData(document)
  // }


  const downloadRewardsDocumentForPreview = async (documentId) => {
    try{
      const res = await fetchApi(`${GetCompanyRewardsDocuments}/${documentId}`, "GET");
      if(res?.data?.message){
        toast.error(res?.data?.message);
      }else{
        if(res?.data?.reward_document){
          // downloadFile(res?.data?.reward_document, title);
        //   window.console.log("hello")
          setPdfFile(res?.data?.reward_document)
          showPreviewPopup(true);
        }else{
          toast.error("No document found to download");
        }
        
      }

    }catch(err){
      toast.error(err);
    }

    
  }

  const HandleEnterKeyFileRename = (e, documentID) => {
    if(e.key === 'Enter'){
      renameDocument(documentID); 
      setActiveRename(null);
    }
  }



  return (
    
    <React.Fragment>
      <UploadDiv>
        { loading ? (
          <div style={{ display: "flex", width: "100%", flexWrap: "wrap",margin:"unset" }}>
            {Array.from({ length: 20 }).map((_, index) => (
              <SkeletonLoder key={index} width={"395px"} height={"200px"} style={{margin:"0px 20px 20px 0px"}}/>
            ))}
          </div>
        ):
          !documentsData.length ? <NoData>No data found</NoData> : documentsData && documentsData?.map( (document) => {
            const fileExtension = document?.document.split('.').pop().toLowerCase(); 
            {/* window.console.log("fileExtension",fileExtension) */}
            {/* window.console.log("document",document) */}
            return(
              <FileDocumentThumbnail key={document.id}>
                <DocumentImage isDirection={"row"} isHovered={document.id==activeDocumentIndex} onMouseEnter={()=>{setActiveDocumentIndex(document.id)}} onMouseLeave={()=>{setActiveDocumentIndex(null)}} >
                  <LazyImage src={ImageUrl+'/'+document.document} fallbackImage={ImageUrl + "/health-data/health-doc-fallback.png"} />
                  <div className="buttonGroup">
                    { fileExtension !== 'plain' && (
                      <div className="previewFileButton"  onClick={()=>fileExtension === 'pdf' ?  downloadRewardsDocumentForPreview(document.id)   : DetailsHandle(document)} >
                        {RecognitionEyeIcon("white")}
                         View Report
                      </div>
                    )}
                    <div className="downloadFileButton" onClick={() => downloadRewardsDocument(document) }>
                      {DownloadReportIcon("white")}
                    </div>
                  </div>
                </DocumentImage>
                <DocumentDetails>
                  <div className="title" title={document.document_name}>
                    { activeRename != document.id ? document.document_name : <input type="text" ref={fileNameRef} value={fileNameForRename} className='documentTitleInput' 
                      onChange={(e)=>{ setFileNameForRename(e.target.value)}} onBlur={()=>{ renameDocument(document.id); setActiveRename(null);}} onKeyDown={(e)=> HandleEnterKeyFileRename(e, document.id)} /> }
                    <div className='upload-date'>{dayjs(document?.created_at).format("MMMM DD, YYYY")}</div>
                  </div>
                  <div className="documentOptionsDiv">
  
                    {/* <LazyImage alt="image" src={ImageUrl + "/images/rewards-management/three_dots_image.png"} /> */}
                    {VerticalDotsIcon()}
  
                    <CustomDropdownMenue id="dropdown-recurring">
                      <CustomDropdownMenuItem
                        eventKey={1}
                        onClick={() => {
                          setActiveRename(document.id);
                          window.console.log("document.document_name",document.document_name)
                          setFileName(document.document_name);
                          fileNameRef.current && fileNameRef.current.focus()
                        //   window.setTimeout(()=>{fileNameRef.current && fileNameRef.current.focus()}, 0)
                        }}
                        style={{height:"auto"}}
                      >
                        Rename
                      </CustomDropdownMenuItem>
                      {/* <hr /> */}
                      {/* <CustomDropdownMenuItem
                        eventKey={2}
                        onClick={() => {
                          setShowDeleteModal(true);
                          setActiveDeleteModal(document.id);
                        }}
                      >
                        Delete
                      </CustomDropdownMenuItem>{" "} */}
                    
                    </CustomDropdownMenue>
  
                  </div>
                  
                  
                  {/* {
                    (showDeleteModal && activeDeleteModal == document.id) && <DeletePopupModal showModal={true} setShowDeleteModal={setShowDeleteModal} deleteRewardsDocument={deleteRewardsDocument} doc_id={document.id} />
                  } */}
                </DocumentDetails>
                
              </FileDocumentThumbnail>)
          })
        }
        {detailPopup && documentData && <PreviewImageModal showModal={showDetailPopup} documentData={documentData} onClose={closeDetailPopup} />}
        {/* {previewPopup && <PdfPreview  pdfFile={pdfFile} />} */}
        <PdfPreview
          pdfFile={pdfFile}
          isOpen={previewPopup}
          onClose={closeModal} 
        />


      </UploadDiv>
    </React.Fragment>
  )
}

ReportsDashboard.propTypes = {
  selectedRewardCompany: PropTypes.string,
  companyInfo:PropTypes.object,
  user:PropTypes.object
}

const mapStateToProps = (state) => ({
  companyRewardsDocuments: state.wellnessDashboard.companyRewardsDocuments
});

// const mapDispatchToProps = (dispatch) => ({
// });

export default connect(mapStateToProps, null) (ReportsDashboard);